<script>
import vNotification from "../table/vNotification.vue";

export default {
  name: "BaseMessagingMixin",
  components: {
    vNotification
  },
  methods: {
    alertMessage: async function (message, type) {
      this.$notify({
        clean: true,
      });

      this.$notify({
        title: message,
        type: type,
      });
    },
  },
}
</script>

<style scoped>

</style>
